var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditOp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2179 3.81469C11.4292 3.60344 11.4292 3.25135 11.2179 3.05094L9.95042 1.78344C9.75 1.57219 9.39792 1.57219 9.18667 1.78344L8.19 2.77469L10.2213 4.80594M1.625 9.3451V11.3764H3.65625L9.64708 5.3801L7.61583 3.34885L1.625 9.3451Z",
    fill: "#5921F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditOp);
export default __webpack_public_path__ + "static/media/EditOP.4b861efd60acdf155ece0bb5bcb2d646.svg";
export { ForwardRef as ReactComponent };